<script setup>
import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
  text: {},
  storeNamespace: {}
})

const emit = defineEmits(['close-dialog', 'resetItemState'])

const store = useStore()

const step = ref(1)
const isUpload = ref(false)
const fileImport = ref(null)
const messageSnackbar = ref(false)
const timeout = ref(5000)

const importItems = computed(() => store.state[props.storeNamespace]['importItems'])
const importLoading = computed(() => store.state[props.storeNamespace]['importLoading'])
const uploadLoading = computed(() => store.state[props.storeNamespace]['uploadLoading'])

watch(importItems, () => {
  if (!uploadLoading.value && isUpload.value && importItems.value && importItems.value.length) {
    step.value = 2
  }
})

watch(importLoading, () => {
  if (importLoading.value) {
    setTimeout(() => {
      messageSnackbar.value = true
    }, 5000)
  }
})

const importHandle = async () => {
  await store.dispatch(props.storeNamespace + '/import')
  await store.dispatch(props.storeNamespace + '/resetImportState')
}

const submitFile = async () => {
  if (fileImport.value) {
    const formData = new FormData()
    formData.append('filename', fileImport.value)
    store.dispatch(props.storeNamespace + '/uploadFile', formData)
    isUpload.value = true
  }
}

const resetImport = async () => {
  await store.dispatch(props.storeNamespace + '/resetImportState')
  isUpload.value = false
  fileImport.value = null
  step.value = 1
}

const handleBackClick = async () => {
  await store.dispatch(props.storeNamespace + '/resetImportState')
  step.value = 1
}

const handleCancelClick = async () => {
  await emit('close-dialog')
  await resetImport()
}

const handleImportClick = async () => {
  await emit('resetItemState')
  try {
    await importHandle()
    await emit('close-dialog')
  } catch (e) {
    console.log(e)
  }

  await resetImport()
}
</script>

<template>
  <div>
    <v-stepper v-model="step" color="primary" flat elevation="0">
      <v-stepper-header style="box-shadow: 0 0 0 0">
        <v-stepper-item color="primary" :complete="step > 1" :value="1"
          >Import <i>{{ text }}</i> from Excel file</v-stepper-item
        >
        <v-stepper-item color="primary" :value="2"
          >Check <i>{{ text }}</i></v-stepper-item
        >
      </v-stepper-header>
      <v-stepper-window v-model="step">
        <v-stepper-window-item :value="1">
          <div class="py-2" style="display: flex; align-items: center">
            <v-file-input
              color="primary"
              label="File input"
              truncate-length="50"
              hide-details
              v-model="fileImport"
              density="compact"
            ></v-file-input>
            <v-btn
              variant="flat"
              class="ml-3 mr-3 float-right"
              color="primary"
              @click="submitFile()"
              :loading="isUpload && uploadLoading"
              center
            >
              Import
              <v-icon right dark>mdi-cloud-upload</v-icon>
            </v-btn>
          </div>
          <div class="float-right mt-7">
            <v-btn variant="text" color="primary" @click="handleCancelClick()"> Cancel </v-btn>
          </div>
        </v-stepper-window-item>

        <v-stepper-window-item :value="2">
          <div v-if="importItems && !uploadLoading">
            <slot></slot>
          </div>
          <div class="mt-6">
            <v-btn size="small" color="primary" center variant="flat" @click="handleBackClick()">
              Back
            </v-btn>
            <v-btn
              size="small"
              variant="flat"
              :loading="importLoading"
              color="primary"
              class="ml-2 float-right"
              @click="handleImportClick()"
              center
            >
              Import
            </v-btn>
            <v-btn
              size="small"
              variant="text"
              color="primary"
              class="ml-2 float-right"
              @click="handleCancelClick()"
            >
              Cancel
            </v-btn>
          </div>
        </v-stepper-window-item>
      </v-stepper-window>
    </v-stepper>
    <v-snackbar v-model="messageSnackbar" :timeout="timeout" color="primary">
      Importing, Please wait...
      <template v-slot:action="{ attrs }">
        <v-btn color="primary" v-bind="attrs" @click="messageSnackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
